export default __webpack_public_path__ + "static/media/1.ec90e44d.png";